import { render, staticRenderFns } from "./LessonClassEdit.vue?vue&type=template&id=2a80d135&scoped=true&"
import script from "./LessonClassEdit.vue?vue&type=script&lang=ts&"
export * from "./LessonClassEdit.vue?vue&type=script&lang=ts&"
import style0 from "./LessonClassEdit.vue?vue&type=style&index=0&id=2a80d135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80d135",
  null
  
)

export default component.exports